import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faGrid2,
  faGear,
  faRightFromBracket,
  faCircle,
  faPlus,
  faPen,
  faTrash,
  faChevronDown,
  faBars,
  faBarsStaggered,
  faXmark,
  faArrowLeft,
  faDownload,
  faUpload,
  faUser,
  faQuestion,
  faFileLines,
  faChartColumn,
  faUsers,
  faSpinner,
  faKey,
  faChevronLeft,
  faChevronRight,
  faChevronsRight,
  faChevronsLeft,
  faFilter,
  faArrowRotateRight,
  faCheck,
  faUserCircle,
  faLocationDot,
  faFlask,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileZipper,
  faFile,
} from '@fortawesome/pro-regular-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconMap = new Map<string, IconDefinition>([
    // Navigation & UI
    ['menu', faBars],
    ['menu-open', faBarsStaggered],
    ['close', faXmark],
    ['arrow-back', faArrowLeft],
    ['chevron-down', faChevronDown],
    ['circle', faCircle],
    ['person', faUser],
    ['expand_more', faChevronDown],
    ['logout', faRightFromBracket],

    // Actions
    ['add', faPlus],
    ['edit', faPen],
    ['delete', faTrash],
    ['download', faDownload],
    ['upload', faUpload],
    ['check', faCheck],
    ['close', faXmark],
    ['cancel', faXmark],
    ['success', faCheck],

    // Main navigation
    ['dashboard', faGrid2],
    ['debtors', faFileLines],
    ['assignments', faChartColumn],
    ['employees', faUsers],
    ['settings', faGear],
    ['spinner', faSpinner],
    ['key', faKey],
    ['requests', faFileLines],
    ['customers', faUsers],
    // Pagination
    ['chevrons-left', faChevronsLeft],
    ['chevrons-right', faChevronsRight],
    ['chevron-left', faChevronLeft],
    ['chevron-right', faChevronRight],

    // Filters
    ['filter', faFilter],
    ['refresh', faArrowRotateRight],

    // Stepper
    ['check', faCheck],
    ['map-pin', faLocationDot],
    ['user-circle', faUserCircle],

    // Documents
    ['document-text', faFileLines],
    ['document-upload', faUpload],
    ['document-download', faDownload],
    ['document-delete', faTrash],
    ['document-edit', faPen],

    // Misc
    ['beaker', faFlask], // For testing
    ['location_city', faLocationDot],
    // File types
    ['file', faFile],
    ['file-pdf', faFilePdf],
    ['file-word', faFileWord],
    ['file-excel', faFileExcel],
    ['file-image', faFileImage],
    ['file-archive', faFileZipper],
  ]);

  constructor(library: FaIconLibrary) {
    // Register unique icons from the Map
    library.addIcons(...new Set(this.iconMap.values()));
  }

  getIcon(name: string): IconDefinition {
    const icon = this.iconMap.get(name);
    if (!icon) {
      console.warn(`Icon not found: ${name}`);
      return faQuestion;
    }
    return icon;
  }
}
